angular.module('rightPaneModule')
  .directive("toggleLegend", function() {
      return {
          restrict: "E",
          scope: {
              legendId: '@',
              legendUri: '@'
          },
          templateUrl: '/resources/right-pane/partials/toggle-legend.html',
          controller: ['$scope', '$window', function($scope, $window) {

              var target = document.getElementById($scope.legendId);
              var initialToggle = sessionStorage.getItem("toggleAFLegend");

              $scope.show = true;
              $scope.width = $window.innerWidth;

              var init = function() {
                  $scope.toggle();
                  bindResize();

                  if(initialToggle === 'true') {
                      $scope.show = true;
                      $scope.label = 'SHOW';
                  } else {
                      $scope.show = false;
                      $scope.label = 'HIDE';
                  }
              };

              var bindResize = function() {
                  angular.element($window).bind('resize', function(){

                      $scope.width = $window.innerWidth;
                      updateStyle();

                      // manuall $digest required as resize event
                      // is outside of angular
                      $scope.$digest();
                  });
              };

              var updateStyle = function() {
                  if($scope.width >= 992) {
                      target.style.display = 'block';
                  } else {
                      target.style.display = $scope.show ? 'none' : 'block';
                  }
              };

              $scope.toggle = function() {
                  $scope.show = $scope.show ? false : true;
                  $scope.label = $scope.show ? 'SHOW' : 'HIDE';

                  updateStyle();

                  sessionStorage.setItem("toggleAFLegend", $scope.show);
              };

              init();
          }]
      };
  });
